export enum TestIds {
  TAG_NAME_INPUT = 'tag-name-input',
}

export const tagNameMaxLength = 45;
